import { render, staticRenderFns } from "./mobileIndex.vue?vue&type=template&id=20285b21&scoped=true"
import script from "./mobileIndex.vue?vue&type=script&lang=js"
export * from "./mobileIndex.vue?vue&type=script&lang=js"
import style0 from "./mobileIndex.vue?vue&type=style&index=0&id=20285b21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20285b21",
  null
  
)

export default component.exports